
  <div class="row">
    <div class="col-lg-12 grid-margin">
      <div class="card">
        <div class="card-body upper-header">
          <h4 class="card-title">
            <div class="d-flex bd-highlight">
              <div class="p-2 flex-grow-1 bd-highlight">Darshan Type</div>
              <div class="form-group  text-center pt-4 mt-2 ml-4" style="margin-left: auto !important;">
                <a title="Add Darshan Type" *ngIf = "permissionsService.checkPermission('create_darshan_types')" routerLink="/add-darshan-type"> <i class="fa fa-plus-circle" style="font-size: 35px;cursor: pointer;" aria-hidden="true"></i></a>
              </div>
            </div>
          </h4>
          <div class="table-responsive"  *ngIf="department && department.data && department.data.length">
            <table class="table">
              <thead>
              <tr>
                <th>S.No</th>
                <th>Darshan Type</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let data of department?.data; let i = index">
                <td>
                  <span *ngIf = "page == 1">{{i+1}}</span>
                  <span *ngIf = "page > 1">{{((page - 1 )*perPage) + (i+1)}}</span>
                </td>
                <td>
                  <span *ngIf = "data?.name">{{data?.name}}</span>
                </td>
                <td class="fixed-side">
                    <a title="Delete"  class="ml-4" *ngIf = "permissionsService.checkPermission('delete_darshan_types')" (click)="deleteDepartment(data)"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="p-12" *ngIf="department && department.data && !department.data.length">
            <span class="ng-star-inserted no_data" >No Data found.</span>
          </div>
        </div>
      </div>
    </div>
  </div>

